import { initReactI18next } from 'react-i18next';
import { getDefaultSystemTranslationsMap } from '@common/entities';
import i18next from 'i18next';

const defaultTranslations = getDefaultSystemTranslationsMap();

// Use createInstance() so we have our own i18n instance — isolated from @entrata/i18n
// and any other code that might use the default i18next instance.
const i18n = i18next.createInstance();

const initialLocale =
  new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '').get('locale') ??
  'en-US';

i18n.use(initReactI18next).init({
  lng: initialLocale,
  fallbackLng: 'en-US',
  defaultNS: 'viewer',
  ns: ['viewer'],
  resources: {
    'en-US': {
      viewer: defaultTranslations,
    },
  },
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
    bindI18n: 'languageChanged',
    bindI18nStore: 'added',
  },
});

export default i18n;
